import React from "react";
import {
  Layout,
  Typography,
  Button,
  Space,
  Grid,
  Row,
  Col,
  Card,
} from "antd";
import {
  CheckCircleOutlined,
  SafetyCertificateOutlined,
  StarOutlined,
} from "@ant-design/icons";

import MainHeader from "../components/layout/MainHeader";
import MainFooter from "../components/layout/MainFooter";
import "./BanhoDeOuroSemijoias.css";
import PorqueEscolher from "../components/components/porque_escolher/banho_ouro/porqueescolher";
import ComoFunciona from "../components/components/como_funciona/comoFunciona";
import ProofResultsSection from "../components/components/prova_social/ProofResultsSection";
import WhoWeServeSection from "../components/pra_quem-serve/WhoWeServeSection";
import FAQSection from "../components/components/FAQ/FAQSection.js";
import FloatingCTA from "../components/components/common/FloatingCTA.js";
// import EconomiaVernizChart from "../components/EconomiaVernizChart";

const { Content } = Layout;
const { Title, Paragraph } = Typography;
const { useBreakpoint } = Grid;

function VernizDiamond() {
  const screens = useBreakpoint();
  const isMobile = !screens.md;

  return (
    <Layout>
      <MainHeader />
      <FloatingCTA triggerId="trigger-floating-cta" />

      <Content>
        <section className="section-banho-ouro">
          <div
            style={{
              maxWidth: 1400,
              margin: "0 auto",
              padding: isMobile ? "32px 16px 0" : "48px 20px 0",
            }}
          >
            <div
              style={{
                maxWidth: 980,
                margin: "0 auto",
                textAlign: "center",
                paddingBottom: isMobile ? 32 : 48,
              }}
            >
              <Title
                style={{
                  color: "#fff",
                  fontSize: "clamp(2.2rem, 5vw, 4.8rem)",
                  lineHeight: 1.05,
                  marginBottom: 20,
                }}
              >
                <span className="p-titulo">Verniz Diamond</span> para semijoias
                com brilho <span className="p-titulo">premium</span> e proteção
                reforçada
              </Title>

              <Paragraph
                style={{
                  color: "#ffffffd9",
                  fontSize: isMobile ? 16 : 18,
                  lineHeight: 1.7,
                  maxWidth: 760,
                  margin: "0 auto 28px",
                }}
              >
                Um acabamento de alta performance para quem busca mais brilho,
                aparência sofisticada e proteção extra sem alterar a cor
                original da peça.
              </Paragraph>

              <Space
                wrap
                style={{
                  width: "100%",
                  justifyContent: "center",
                }}
              >
                <Button
                  className="btn-ouro"
                  size="large"
                  href="https://wa.me/5511996064416?text=Olá!%20Quero%20saber%20mais%20sobre%20o%20Verniz%20Diamond."
                  target="_blank"
                  style={{
                    width: isMobile ? "100%" : "auto",
                    maxWidth: isMobile ? 320 : "none",
                  }}
                >
                  Solicitar orçamento
                </Button>
              </Space>
            </div>

            {/* VIDEO */}
            <div
              style={{
                width: "100%",
                borderTopLeftRadius: 24,
                borderTopRightRadius: 24,
                overflow: "hidden",
                background: "#1a1a1a",
                boxShadow: "0 20px 60px rgba(0,0,0,0.35)",
              }}
            >
              <video
                src="/videos/homecompr.mp4"
                autoPlay
                muted
                loop
                playsInline
                preload="auto"
                controls={false}
                poster="/images/capa-video.jpg"
                style={{
                  width: "100%",
                  height: "clamp(280px, 52vw, 720px)",
                  objectFit: "cover",
                  display: "block",
                }}
              />
            </div>
          </div>
        </section>

        <section
          style={{
            background: "#ffffff",
            padding: isMobile ? "56px 16px" : "80px 20px",
          }}
        >
          <div style={{ maxWidth: 1200, margin: "0 auto" }}>
            <div
              style={{
                maxWidth: 900,
                margin: "0 auto 48px",
                textAlign: "center",
              }}
            >
              <Title
                level={2}
                style={{
                  marginBottom: 20,
                  fontSize: "clamp(1.8rem, 3vw, 2.8rem)",
                }}
              >
                O que diferencia o Verniz Diamond na peça?
              </Title>

              <Paragraph
                style={{
                  fontSize: isMobile ? 16 : 18,
                  lineHeight: 1.8,
                  color: "#555",
                  marginBottom: 0,
                }}
              >
                O Verniz Diamond é um acabamento de alta performance voltado para
                realçar o brilho, deixar a peça com aparência mais polida e
                sofisticada e ainda oferecer uma camada extra de proteção. Sua
                proposta principal está no impacto visual e no valor percebido da
                joia, mantendo um acabamento fino, sem aspecto pesado e sem
                alterar a tonalidade original da peça.
              </Paragraph>
            </div>

            <Row gutter={[24, 24]} style={{ marginBottom: 48 }}>
              <Col xs={24} md={8}>
                <Card
                  style={{
                    height: "100%",
                    borderRadius: 20,
                    border: "1px solid #ececec",
                    boxShadow: "0 10px 30px rgba(0,0,0,0.05)",
                  }}
                >
                  <div
                    style={{
                      width: 58,
                      height: 58,
                      borderRadius: "50%",
                      background: "rgba(212, 180, 131, 0.12)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "#d4b483",
                      fontSize: 24,
                      marginBottom: 18,
                    }}
                  >
                    <StarOutlined />
                  </div>

                  <Title level={4}>Brilho intenso</Title>

                  <Paragraph style={{ color: "#555", marginBottom: 0 }}>
                    Entrega uma aparência mais luxuosa e polida, valorizando o
                    acabamento final e aumentando o apelo visual da peça.
                  </Paragraph>
                </Card>
              </Col>

              <Col xs={24} md={8}>
                <Card
                  style={{
                    height: "100%",
                    borderRadius: 20,
                    border: "1px solid #ececec",
                    boxShadow: "0 10px 30px rgba(0,0,0,0.05)",
                  }}
                >
                  <div
                    style={{
                      width: 58,
                      height: 58,
                      borderRadius: "50%",
                      background: "rgba(212, 180, 131, 0.12)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "#d4b483",
                      fontSize: 24,
                      marginBottom: 18,
                    }}
                  >
                    <SafetyCertificateOutlined />
                  </div>

                  <Title level={4}>Proteção extra</Title>

                  <Paragraph style={{ color: "#555", marginBottom: 0 }}>
                    Ajuda a proteger contra oxidação, desgaste do uso diário e
                    riscos superficiais, reforçando a durabilidade da peça.
                  </Paragraph>
                </Card>
              </Col>

              <Col xs={24} md={8}>
                <Card
                  style={{
                    height: "100%",
                    borderRadius: 20,
                    border: "1px solid #ececec",
                    boxShadow: "0 10px 30px rgba(0,0,0,0.05)",
                  }}
                >
                  <div
                    style={{
                      width: 58,
                      height: 58,
                      borderRadius: "50%",
                      background: "rgba(212, 180, 131, 0.12)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "#d4b483",
                      fontSize: 24,
                      marginBottom: 18,
                    }}
                  >
                    <CheckCircleOutlined />
                  </div>

                  <Title level={4}>Acabamento fino</Title>

                  <Paragraph style={{ color: "#555", marginBottom: 0 }}>
                    Sua camada ultrafina preserva o visual da peça sem deixar
                    aspecto plastificado, mantendo elegância e naturalidade.
                  </Paragraph>
                </Card>
              </Col>
            </Row>
          </div>
        </section>
      </Content>

      <MainFooter />
    </Layout>
  );
}

export default VernizDiamond;